<script lang="ts">
	import { storeHeroMenu } from '$lib/js/stores'
	import { is_set_array } from '$lib/js/helpers'
	import { afterNavigate } from '$app/navigation'
	import type { CategoryChild, CategoryChildren, CategoryWithChildren } from '$lib/js/elasticsearch/types'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let category: CategoryChildren | null
	export let selected: number

	const scope = getContextScope()

	$: cleanCats = category?.children_data.filter((cat: CategoryChild) => cat.product_count > 0)
	$: firstActive = cleanCats && is_set_array(cleanCats) ? cleanCats[0]?.id : 0
	$: catActive = cleanCats && is_set_array(cleanCats) && is_set_array(cleanCats[0]?.children_data) ? cleanCats[0].children_data : 0

	function optionFirstHovered(child_cat: CategoryWithChildren) {
		firstActive = child_cat.id
		catActive = child_cat?.children_data
	}

	function hideMenu() {
		selected = 0
		$storeHeroMenu = ''
	}

	afterNavigate(() => {
		$storeHeroMenu = ''
	})
</script>


{#if
	category
	&& $storeHeroMenu === "subcats"
	&& cleanCats
}
	<div class="submenu">
		<div class="container">
			<nav
				class="submenu__inner"
				on:mouseleave={() => hideMenu()}
			>
				<div class="first-level">
					{#each cleanCats as child_cat}
						<a
							href="/{scope}/{child_cat.url_path}"
							class="first"
							class:selected={firstActive === child_cat.id}
							on:mouseenter={() => optionFirstHovered(child_cat)}
						>{child_cat.name}</a>

						<!-- {#if is_set_array(child_cat.children_data)}
							{#each child_cat.children_data as child_cat_2}
								{#if child_cat_2.product_count > 0}
									<a href="/{$storeLang}/{child_cat_2.url_path}" class="second">{child_cat_2.name}</a>
								{/if}
							{/each}
						{/if} -->
					{/each}
				</div>

				{#if is_set_array(catActive)}
					<div class="second-level">
						{#each catActive as child_cat_2}
							{#if child_cat_2.product_count > 0}
								<a href="/{scope}/{child_cat_2.url_path}" class="second">{child_cat_2.name}</a>
							{/if}
						{/each}
					</div>
				{/if}
			</nav>
		</div>
	</div>
{/if}


<style lang="scss">
  .submenu {
    position: fixed;
    right: 0;
    left: 0;
    top: 100px;
    bottom: 0;

    a {
      display: block;
      color: black;
      width: 250px;
    }

    .first-level {
      overflow-y: scroll;
      background: var(--grey);

      a {
        padding: 10px 18px;

        &:hover {
          background: var(--main);
          color: white
        }

        &.selected {
          background: var(--main);
          color: white
        }
      }
    }

    .second-level {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;

      a {
        padding: 5px 20px;

        &:hover {
          color: var(--main);
        }
      }
    }

    &__inner {
      display: flex;
      background: white;
      margin-top: 4px;
      padding: 20px;
      max-height: calc(100vh - 220px);
    }
  }
</style>